const contractName = process.env.REACT_APP_CONTRACT_NAME || [
  'test_v2_nft.openforest.testnet',
];

const rawIpfsGateway = process.env.REACT_APP_IPFS_GATEWAY
  || process.env.REACT_APP_FILEBASE_GATEWAY;
const ipfsGateway = rawIpfsGateway
  ? rawIpfsGateway
    .replace(/\/ipfs\/?$/i, '')
    .replace(/\/+$/i, '')
  : rawIpfsGateway;

export default function getConfig() {
  let config = {
    projectDurationType: 'day',
    walletOFPUrl: 'https://wallet-test.openforestprotocol.org',
    backendApi: 'https://api-dev.openforestprotocol.org',
    indexerApi: 'https://indexer-dev.openforestprotocol.org/projects',
    ipfsGateway,
    mapURL: 'https://api.mapbox.com/geocoding/v5/',
    networkId: 'testnet',
    nodeUrl: 'https://rpc.testnet.fastnear.com',
    walletUrl: 'https://testnet.mynearwallet.com',
    helperUrl: 'https://helper.testnet.near.org',
    contractName,
    deposit: '1', // 1 Yocto Near (1 YoctoNear = 1^-24 Near)
    GAS: '200000000000000',
    occContractName: 'dev_v1_occ.openforest.testnet',
    occContractMethods: {
      viewMethods: ['mt_supply', 'get_token_history'],
    },
    DEFAULT_NEW_ACCOUNT_AMOUNT: '5',
    contractMethods: {
      changeMethods: [
        'add_project',
        'data_upload',
        'update_project_status',
        'update_project_metadata',
      ],
      viewMethods: [
        'get_profile',
        'get_project',
      ],
    },
  };

  if (process.env.REACT_APP_ENV === 'test') {
    config = {
      ...config,
      contractName: [
        'test_v2_nft.openforest.testnet',
        'test_v2_occ.openforest.testnet',
      ],
      projectDurationType: 'day',
      projectTimeLeft: (10 * 60 * 1000), // 10 minutes
      backendApi: 'https://api-test.openforestprotocol.org',
      indexerApi: 'https://indexer-test.openforestprotocol.org/projects',
    };
  }

  if (process.env.REACT_APP_ENV === 'prod') {
    config = {
      ...config,
      contractName: [
        'ofpcore.near',
        'occtoken.near',
      ],
      walletOFPUrl: 'https://wallet.openforestprotocol.org',
      projectDurationType: 'year',
      backendApi: 'https://api.openforestprotocol.org',
      indexerApi: 'https://indexer.openforestprotocol.org/projects',
      networkId: 'mainnet',
      // occContractName: 'occtoken.near',
      projectTimeLeft: (7 * 24 * 60 * 60 * 1000), // 7 days

      nodeUrl: 'https://rpc.mainnet.near.org',
      walletUrl: 'https://app.mynearwallet.com',
      helperUrl: 'https://helper.mainnet.near.org',
    };
  }

  return config;
}
